import LoadingComponent from 'commons/loading/Loading.component';
import { formatTimeAgo } from 'helpers/Datetime.helper';
import { getImageUrl } from 'helpers/Image.helper';
import React from 'react';

const PhotoComponent = (props: any) => {
    const {
        list,
        isInit,
        isOnLoadMore,
        hasMore,
        page,
        handleShowPhotoPopup,
        errorMessage
    } = props;

    // 날짜별로 사진을 그룹화하는 함수
    const groupPhotosByDate = (photos: any[]) => {
        if (!photos || photos.length === 0) return [];

        const groups: { [key: string]: any[] } = {};
        
        photos.forEach((photo) => {
            const date = new Date(photo.createdAt || photo.updatedAt || Date.now());
            const dateKey = date.toISOString().split('T')[0]; // YYYY-MM-DD 형식
            
            if (!groups[dateKey]) {
                groups[dateKey] = [];
            }
            groups[dateKey].push(photo);
        });

        // 날짜별로 정렬 (최신 날짜가 먼저 오도록)
        return Object.entries(groups)
            .sort(([a], [b]) => new Date(b).getTime() - new Date(a).getTime())
            .map(([dateKey, photos]) => ({
                dateKey,
                photos,
                displayDate: formatDisplayDate(dateKey)
            }));
    };

    // 날짜 표시 형식을 포맷하는 함수
    const formatDisplayDate = (dateKey: string) => {
        const photoDate = new Date(dateKey);
        return formatTimeAgo(photoDate);
    };

    const photoGroups = groupPhotosByDate(list);

    return (
        <>
            {/* 탭 설명 */}
            <div className="bg-white border border-gray-200 rounded-lg p-4">
                <div className="flex items-start">
                    <div className="flex-shrink-0">
                        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </div>
                    <div className="ml-3">
                        <h3 className="text-sm font-medium text-gray-900">사진첩</h3>
                        <p className="text-sm text-gray-600 mt-1">지망생이 등록한 다양한 사진들을 확인할 수 있습니다. 프로필 사진부터 일상 사진까지 한눈에 보세요.</p>
                    </div>
                </div>
            </div>
            
            {isInit &&
                <>
                    {photoGroups.length > 0 &&
                        <div className="space-y-6">
                            {photoGroups.map((group) => (
                                <div key={group.dateKey} className="space-y-3">
                                    {/* 날짜 헤더 */}
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0">
                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <h4 className="ml-2 text-sm font-medium text-gray-700">{group.displayDate}</h4>
                                        <span className="ml-2 text-xs text-gray-400">({group.photos.length}장)</span>
                                    </div>
                                    
                                    {/* 사진 그리드 */}
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                                        {group.photos.map((item: any, index: number) => (
                                            <div key={`${group.dateKey}-${index}`} className="relative group rounded-lg overflow-hidden">
                                                <div
                                                    onClick={() => handleShowPhotoPopup(index)}
                                                    className="aspect-w-1 aspect-h-1">
                                                    <img
                                                        src={getImageUrl(item?.imageInfo, 500, 500)}
                                                        alt={`item ${index + 1}`}
                                                        className="w-full h-full object-contain"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    
                    {!errorMessage && photoGroups.length === 0 &&
                        <div className="text-center py-8">
                            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <p className="text-gray-500 text-sm">등록된 사진이 없습니다.</p>
                        </div>
                    }
                    
                    {errorMessage &&
                        <div className="w-full text-center py-8 text-red-500 bg-red-100 border border-red-400 rounded">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M12 2a10 10 0 110 20 10 10 0 010-20z" />
                            </svg>
                            {errorMessage}
                        </div>
                    }
                </>
            }
            {isOnLoadMore && (
                <LoadingComponent />
            )}
        </>
    );
};

export default PhotoComponent;